import * as React       from 'react';
import Button           from '@mui/material/Button';
import Typography       from '@mui/material/Typography';
import CardMedia        from '@mui/material/CardMedia';
import { useAuth }      from 'auth/AuthProvider';
import {
    apiEndpoint,
    CONNECT_APPLE_HEADER,
    CONNECT_APPLE_BUTTON,
    THANK_YOU_HEADER,
    THANK_YOU_TEXT,
    THANK_YOU_BUTTON,
    CONNECT_APPLE_SUBHEADER,
    TEACHERS_GUIDE_LINK,
    CONNECT_APPLE_LINK,
    STARTING_CLASS_LINK,
}                           from 'config/config';
import TEACHERS_GUIDE_IMAGE from 'images/guide_ill.png';
import FormLayout           from 'ui/components/FormLayout';
import useQueryParam        from 'hooks/useQueryParam';
import { Link } from '@mui/material';


export default function ConnectApple() {
    const migrated = useQueryParam('migrated');
    // const restorationToken = useQueryParam("restoration_token");
    const auth = useAuth();
    if (migrated === 'true') {
        return (
            <FormLayout showBackButton={false} white>
                <CardMedia
                    component="img"
                    sx={{maxWidth: 364, maxHeight: 250, objectFit: 'cover'}}
                    image={TEACHERS_GUIDE_IMAGE}
                />
                <Typography variant='h6'>
                    {THANK_YOU_HEADER}
                </Typography>
                <Typography variant='caption' textAlign='center'>
                    {THANK_YOU_TEXT}
                </Typography>
                <Button variant='contained' sx={{px: 6}} onClick={()=>{window.location.href = STARTING_CLASS_LINK}}>
                    {THANK_YOU_BUTTON}
                </Button>
                <Link
                    align='center'
                    underline='none'
                    href={TEACHERS_GUIDE_LINK}
                    target='_blank'
                >
                    {CONNECT_APPLE_LINK}
                </Link>
            </FormLayout>
        )
    } else {
        const sessionToken = auth.session ? auth.session.token : '';
        // const redirectUri = encodeURIComponent(window.location.href)
        return (
            <FormLayout showBackButton={false} white>
                <CardMedia
                    component="img"
                    sx={{maxWidth: 364, maxHeight: 250, objectFit: 'cover'}}
                    image={TEACHERS_GUIDE_IMAGE}
                />
                <Typography
                    variant='h6'
                    fontSize={22}
                    align='center'
                >
                    {CONNECT_APPLE_HEADER}
                </Typography>
                <Typography align='center' variant='caption'>
                    {CONNECT_APPLE_SUBHEADER}
                </Typography>
                <Button variant='contained' sx={{px: 6}} onClick={()=>{
                    window.location.href = `${apiEndpoint}/teacher/oauth/access?redirect_uri=\
                        ${encodeURIComponent(window.location.href + "?")}&session=${sessionToken}`
                }}>
                    {CONNECT_APPLE_BUTTON}
                </Button>
                <Link
                    align='center'
                    underline='none'
                    href={TEACHERS_GUIDE_LINK}
                    target='_blank'
                >
                    {CONNECT_APPLE_LINK}
                </Link>
            </FormLayout>
        )
    };
};